import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { CATEGORY_META } from "../lib/categories";
import { BusinessCard } from "../components/BusinessCard";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Search } from "lucide-react";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";

export default function CategoryDetail() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState(q);
  const meta = CATEGORY_META[slug] || {};
  const Icon = meta.Icon;

  const fetchData = async (query) => {
    const { data } = await api.get("/businesses", { params: { category: slug, q: query || undefined, limit: 30 } });
    setItems(data.items);
    setTotal(data.total);
  };
  useEffect(() => { fetchData(q); }, [slug, q]);

  const submit = (e) => {
    e.preventDefault();
    setParams(search ? { q: search } : {});
  };

  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-8 py-12" data-testid="category-detail-page">
      <Seo
        title={`${slug.replace(/-/g, " ")} providers — BizzAtlas`}
        description={`Browse ${total} verified ${slug.replace(/-/g, " ")} providers on BizzAtlas.`}
        canonicalPath={`/category/${slug}`}
      />
      <div className="mb-4">
        <Breadcrumbs items={[
          { label: "BizzAtlas", to: "/" },
          { label: "Categories", to: "/categories" },
          { label: slug.replace(/-/g, " ") },
        ]} />
      </div>
      <div className="flex items-center gap-4 mb-10">
        <div className="h-14 w-14 rounded-lg grid place-items-center text-white" style={{ background: meta.accent || "#0F172A" }}>
          {Icon && <Icon className="h-7 w-7" />}
        </div>
        <div>
          <h1 className="font-display text-4xl tracking-tight capitalize">{slug.replace(/-/g, " ")}</h1>
          <div className="text-sm text-zinc-500">{total} provider{total === 1 ? "" : "s"} listed</div>
        </div>
      </div>

      <form onSubmit={submit} className="mb-8 max-w-xl">
        <div className="flex items-center gap-2 rounded-lg border border-zinc-300 bg-white p-1.5">
          <Search className="h-4 w-4 ml-3 text-zinc-400" />
          <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder={`Search in ${slug.replace(/-/g, " ")}`}
                 className="border-0 focus-visible:ring-0 focus-visible:ring-offset-0" data-testid="cat-search-input" />
          <Button type="submit" className="btn-brand" data-testid="cat-search-submit">Search</Button>
        </div>
      </form>

      {items.length === 0 ? (
        <div className="text-center py-24 border border-dashed rounded-xl">
          <div className="text-zinc-400 mb-3 text-sm font-mono-tag uppercase tracking-widest">No providers yet</div>
          <div className="text-zinc-800 font-display text-2xl mb-3">Be the first to list here.</div>
          <Button onClick={() => nav("/list-business")} className="btn-brand" data-testid="cat-empty-cta">List your business</Button>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((b, i) => <BusinessCard b={b} idx={i} key={b.id} />)}
        </div>
      )}
    </div>
  );
}
